import { render, staticRenderFns } from "./MessageArea.vue?vue&type=template&id=99ebfebe"
import script from "./MessageArea.vue?vue&type=script&lang=js"
export * from "./MessageArea.vue?vue&type=script&lang=js"
import style0 from "./MessageArea.vue?vue&type=style&index=0&id=99ebfebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports